import { render, staticRenderFns } from "./BetslipHeader.vue?vue&type=template&id=acf4caa6&scoped=true"
import script from "./BetslipHeader.vue?vue&type=script&lang=js"
export * from "./BetslipHeader.vue?vue&type=script&lang=js"
import style0 from "./BetslipHeader.vue?vue&type=style&index=0&id=acf4caa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf4caa6",
  null
  
)

export default component.exports